export const fmtMoeda = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const fmtData = (iso: string) => {
  if (!iso) return '-';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

/**
 * Data e hora no fuso de quem vê. `fmtDataHora`, abaixo, corta a string ISO e
 * mostraria o horário em UTC — três horas adiantado para um prazo como o do
 * desbloqueio em confiança.
 */
export const fmtDataHoraLocal = (iso: string) =>
  new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

export const fmtDataHora = (iso: string | null) => {
  if (!iso) return 'Nunca acessou';
  const [date, time] = iso.split('T');
  const [y, m, d] = date.split('-');
  const [h, min] = time.split(':');
  return `${d}/${m}/${y} às ${h}:${min}`;
};

export const perfis: Record<string, { label: string; cor: string }> = {
  admin: { label: 'Administrador', cor: 'bg-primary-50 text-primary-700 border-primary-200' },
  operador: { label: 'Operador', cor: 'bg-accent-100 text-accent-900 border-accent-300' },
  visualizador: {
    label: 'Visualizador',
    cor: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  },
};

export const statusUsuario: Record<string, { label: string; cor: string }> = {
  ativo: { label: 'Ativo', cor: 'bg-green-50 text-green-700 border-green-200' },
  pendente: { label: 'Pendente', cor: 'bg-amber-50 text-amber-700 border-amber-200' },
  inativo: { label: 'Inativo', cor: 'bg-red-50 text-red-700 border-red-200' },
};

export const statusCobranca: Record<string, { label: string; cor: string }> = {
  pago: { label: 'Pago', cor: 'bg-green-50 text-green-700 border-green-200' },
  pendente: { label: 'Pendente', cor: 'bg-amber-50 text-amber-700 border-amber-200' },
  atrasado: { label: 'Atrasado', cor: 'bg-red-50 text-red-700 border-red-200' },
};
